<template>
  <qx-card title="调度信息">
    <qx-detail-box :data="detailData.base">
      <section slot="vehicleDetail">
        <DetailItem
            :detailItemList="vehicleDetailItemList"
            :orderDetail="orderDetail"
            propName="vehicleDetail"
        />
      </section>


      <section slot="cargoInfoDetail" v-if="isEdit===''">
        <div
            class="detail-item-inline-box"
            :style="{ '--column-count': cargoInfoDetailItemList.length }" >
          <div
              v-for="(item, index) in cargoInfoDetailItemList"
              :key="index"
              class="detail-item-column">
            <DetailItem
                :detailItemList="item"
                :orderDetail="orderDetail"
                propName="cargoInfoDetail"
                :detailItemHorizontal="true"
            ></DetailItem>
          </div>
        </div>
      </section>

      <section slot="cargoInfoDetail" v-if="isEdit==='edit'">

        <div style="display: flex" >
          <qx-custom-form :formData="orderLoadInfo" ref="orderLoadInfo" :noSubBtn="true"></qx-custom-form>
          <qx-custom-form :formData="driverLoadInfo" ref="driverLoadInfo" :noSubBtn="true"></qx-custom-form>
          <qx-custom-form :formData="orderUnloadInfo" ref="orderUnloadInfo" :noSubBtn="true"></qx-custom-form>
          <qx-custom-form :formData="driverUnloadInfo" ref="driverUnloadInfo" :noSubBtn="true"></qx-custom-form>
        </div>
        <div style="display: flex;">
          <el-button type="primary" @click="handelCargoInfoSub">保存</el-button>
        </div>


      </section>

      <section slot="freightDetail">
        <DetailItem
            :detailItemList="freightDetailItemList"
            :orderDetail="orderDetail"
            propName="freightDetail"
        />
      </section>
    </qx-detail-box>

  </qx-card>
</template>

<script>
import DetailItem from './components/detailItem';
import {
  getFileUrl,
} from 'api';
import {updateLoadingAndUnloadDatas} from 'api/operate';

export default {
  components: {
    DetailItem,

  },
  data () {
    return {
      isEdit: '',
      orderLoadInfo: {
        form: [],
      },
      driverLoadInfo: {
        form: [],
      },
      orderUnloadInfo: {
        form: [],
      },
      driverUnloadInfo: {
        form: [],
      },
      orderDetail: {},
      detailRes: {},
      vehicleDetailItemList: [ // 车辆信息
        {label: '车牌', value: 'plateNumber'},
        {label: '车类', value: 'vehicleClassName'},
        {label: '车型', value: 'vehicleCategory'},
        {label: '能源类型', value: 'energyTypeName'},
        {label: '车辆备注', value: 'vehicleRemark'},
        {label: '主驾', value: 'driverName'},
      ],
      // 装卸货信息
      cargoInfoDetailItemList: [],
      freightDetailItemList: [ // 运费信息
        {label: '结算方式', value: 'settlementMethodStr'},
        {label: '结算单价', value: 'settlementUnitPrice'},
        {label: '原结算运费', value: 'originalSettlementPrice', remark: '原结算运费=结算单价*结算方式'},
        {label: '拉运货值', value: 'goodsUnitPrice'},
        {label: '货损扣重比例', value: 'deductionsScaleDouble'},
        {label: '扣损金额', value: 'deductions'},
        {label: '结算金额', value: 'settlementPrice', remark: '结算金额=原结算运费-扣损金额'},
      ],
      detailData: {
        base: {
          label: '',
          tableData: {
            title: [
              {
                prop: 'vehicleDetail',
                label: '车辆信息',
                slot: true,
                span: 1,
              },
              {
                prop: 'cargoInfoDetail',
                label: '装卸货信息',
                slot: true,
                remark: '装/卸货点：若是围栏触发，则显示【围栏名称】，否则显示小程序定位位置',
                span: 1,
              },
              {
                prop: 'freightDetail',
                label: '运费信息',
                slot: true,
                span: 1,
              },
            ],
            data: {},
            approveData: {},
          },
        },
      },
    };
  },
  computed: {
    colSpan () {
      const total = 24;
      const minSpan = 4;
      return parseInt(total / this.orderInfo.length, 10) < minSpan ? minSpan : parseInt(total / this.orderInfo.length, 10);
    },
  },
  methods: {
    async findImgUrlById (detailRes) {
      const aImgName = ['loadingPic', 'unloadPic'];
      let flowIds = [];
      for (let imgItem of aImgName) {
        let imgStr = detailRes[imgItem];
        if (imgStr) {
          imgStr = imgStr.replaceAll('[', '').replaceAll(']', '');
          flowIds.push(imgStr);
        }
      }
      const imgRes = await getFileUrl({
        flowIds: flowIds.join(),
      });
      for (let imgItem of aImgName) {
        let imgStr = detailRes[imgItem];
        if (imgStr) {
          imgStr = imgStr.replaceAll('[', '').replaceAll(']', '');
        }
        imgRes.items.forEach((item) => {
          if (`${item.flowId}` === `${imgStr}`) {
            detailRes[imgItem + 'Url'] = item.fullPath;
            detailRes[imgItem] = [{
              id: `${item.flowId}`,
              url: item.fullPath,
            }];
          }
        });
      }
    },
    // 详情数据（用来展示）
    setBaseData (detailRes) {
      let orderDetail = detailRes.dZOrderListOut == null ? detailRes.dZDriverOrderInfo : detailRes.dZOrderListOut;
      this.orderDetail = {
        base: {
          vehicleDetail: this.getvehicleDetailData(detailRes, orderDetail),
          cargoInfoDetail: this.getCargoInfoDetailData(detailRes),
          freightDetail: this.getFreightDetailData(orderDetail),
        },
      };
      // 将对应模块的 详情数据 赋给 data 即可展示在页面上展示
      this.detailData.base.tableData.data = this.orderDetail.base;
    },
    // 车辆信息
    getvehicleDetailData (detailRes, dZOrderListOut) {
      return {
        plateNumber: dZOrderListOut.plateNumber,
        driverName: dZOrderListOut.driverName + ' / ' + dZOrderListOut.driverPhone,
        vehicleClassName: detailRes.vehicleClassName,
        vehicleCategory: detailRes.vehicleCategory,
        energyTypeName: detailRes.energyTypeName,
        vehicleRemark: detailRes.vehicleRemark,
      };
    },
    getDriverDetailItem (systemLoad, driverLoad, item, detailRes) {
      const _this = this;
      let driverDetailItem = [];
      for (const itemKey of item) {
        driverDetailItem.push({value: 'driver' + itemKey,
          type: itemKey.indexOf('Url') > -1 ? 'img' : itemKey.indexOf('Time') > -1 ? 'date' : 'input',
          attr: itemKey.indexOf('Url') > -1 ? {limit: 1} : itemKey.indexOf('Time') > -1 ? {type: 'datetime', time: '00:00:00', format: 'yyyy-MM-dd HH:mm:ss', valueFormat: 'yyyy-MM-dd HH:mm:ss'} : '',
          isDifferent: itemKey.indexOf('unload') > -1 ? false : !(systemLoad && driverLoad && systemLoad[itemKey] == driverLoad[itemKey]),
          onChange: async (val) => {
            await _this.itemValueChange(_this, detailRes, itemKey, val, true);
          },
        });
      }
      return driverDetailItem;
    },
    async itemValueChange (_this, detailRes, itemKey, val, isDriver = false) {
      _this.cargoInfoDetailItemList = [];
      _this.orderLoadInfo = {
        form: [],
      };
      _this.driverLoadInfo = {
        form: [],
      };
      _this.orderUnloadInfo = {
        form: [],
      };
      _this.driverUnloadInfo = {
        form: [],
      };

      if (isDriver) {
        detailRes.dZDriverOrderInfo[itemKey] = val;
        _this.detailRes.dZDriverOrderInfo[itemKey] = val;
      } else {
        detailRes.dZOrderListOut[itemKey] = val;
        _this.detailRes.dZOrderListOut[itemKey] = val;
      }

      await _this.setBaseData(detailRes);
      _this.handleForm();
    },
    getCargoInfoDetailData (detailRes) {
      const _this = this;
      const {dZOrderListOut: systemData, dZDriverOrderInfo: driverData} = detailRes;

      // 提取系统装货和卸货数据
      const systemLoad = systemData ? {
        loadingPicUrl: systemData.loadingPicUrl || '',
        weightNumber: systemData.weightNumber || '',
        loadingTime: systemData.loadingTime || '',
        tareWeightDouble: systemData.tareWeightDouble || '',
        grossWeightDouble: systemData.grossWeightDouble || '',
        netWeightDouble: systemData.netWeightDouble || '',
        source: systemData.source || '',
      } : null;

      const systemUnload = systemData ? {
        unloadPicUrl: systemData.unloadPicUrl || '',
        unloadNumber: systemData.unloadNumber || '',
        unloadTime: systemData.unloadTime || '',
        unloadGrossWeight: systemData.unloadGrossWeight || '',
        unloadTareWeight: systemData.unloadTareWeight || '',
        des: systemData.des || '',
        unloadNetWeightDouble: systemData.unloadNetWeightDouble || '',
      } : null;

      // 提取司机装货和卸货数据
      const driverLoad = driverData ? {
        loadingPicUrl: driverData.loadingPicUrl || '',
        weightNumber: driverData.weightNumber || '',
        loadingTime: driverData.loadingTime || '',
        tareWeightDouble: driverData.tareWeightDouble || '',
        grossWeightDouble: driverData.grossWeightDouble || '',
        netWeightDouble: driverData.netWeightDouble || '',
        source: driverData.source || '',
      } : null;

      const driverUnload = driverData ? {
        unloadPicUrl: driverData.unloadPicUrl || '',
        unloadNumber: driverData.unloadNumber || '',
        unloadTime: driverData.unloadTime || '',
        unloadGrossWeight: driverData.unloadGrossWeight || '',
        unloadTareWeight: driverData.unloadTareWeight || '',
        des: driverData.des || '',
        unloadNetWeightDouble: driverData.unloadNetWeightDouble || '',
      } : null;
      // 比较装货和卸货数据是否一致
      const isLoadMatch = systemLoad && driverLoad && JSON.stringify(systemLoad) === JSON.stringify(driverLoad);
      const isUnloadMatch = systemUnload && driverUnload && JSON.stringify(systemUnload) === JSON.stringify(driverUnload);

      // 动态调整 cargoInfoDetailItemList
      this.cargoInfoDetailItemList = [];

      if (!systemData && !driverData) {
        // 如果两者都不存在，返回空数组
        return;
      }
      if (!driverData) {
        // 只有系统数据
        this.cargoInfoDetailItemList.push([
          { label: '装货磅单', value: 'loadingPicUrl', type: 'img', attr: {limit: 1} },
          { label: '装货磅单号', value: 'weightNumber', type: 'input' },
          { label: '装货时间', value: 'loadingTime', type: 'date', attr: {type: 'datetime', time: '00:00:00', format: 'yyyy-MM-dd HH:mm:ss', valueFormat: 'yyyy-MM-dd HH:mm:ss'} },
          { label: '装货皮重', value: 'tareWeightDouble', type: 'input' },
          { label: '装货毛重', value: 'grossWeightDouble', type: 'input' },
          { label: '装货净重', value: 'netWeightDouble', type: 'input'},
          { label: '装货点', value: 'source', type: 'input' },
        ]);
        this.cargoInfoDetailItemList.push([
          { label: '卸货磅单', value: 'unloadPicUrl', type: 'img', disabled: true, attr: {limit: 1} },
          { label: '卸货磅单号', value: 'unloadNumber', type: 'input', disabled: true },
          { label: '卸货时间', value: 'unloadTime', type: 'date', attr: {type: 'datetime', time: '00:00:00', format: 'yyyy-MM-dd HH:mm:ss', valueFormat: 'yyyy-MM-dd HH:mm:ss'}, disabled: true },
          { label: '卸货皮重', value: 'unloadTareWeight', type: 'input', disabled: true},
          { label: '卸货毛重', value: 'unloadGrossWeight', type: 'input', disabled: true },
          { label: '卸货净重', value: 'unloadNetWeightDouble', type: 'input', disabled: true },
          { label: '卸货点', value: 'des', type: 'input', disabled: true },
        ]);
        return {
          loadingPicUrl: detailRes.dZOrderListOut.loadingPicUrl ? detailRes.dZOrderListOut.loadingPicUrl : '',
          weightNumber: detailRes.dZOrderListOut.weightNumber ? detailRes.dZOrderListOut.weightNumber : '',
          loadingTime: detailRes.dZOrderListOut.loadingTime ? detailRes.dZOrderListOut.loadingTime : '',
          tareWeightDouble: detailRes.dZOrderListOut.tareWeightDouble ? detailRes.dZOrderListOut.tareWeightDouble : '',
          grossWeightDouble: detailRes.dZOrderListOut.grossWeightDouble ? detailRes.dZOrderListOut.grossWeightDouble : '',
          netWeightDouble: detailRes.dZOrderListOut.netWeightDouble ? detailRes.dZOrderListOut.netWeightDouble : '',
          source: detailRes.dZOrderListOut.source ? detailRes.dZOrderListOut.source : '',

          // unloadPicUrl: detailRes.dZOrderListOut.unloadPicUrl ? detailRes.dZOrderListOut.unloadPicUrl : '',
          // unloadNumber: detailRes.dZOrderListOut.unloadNumber ? detailRes.dZOrderListOut.unloadNumber : '',
          // unloadTime: detailRes.dZOrderListOut.unloadTime ? detailRes.dZOrderListOut.unloadTime : '',
          // unloadGrossWeight: detailRes.dZOrderListOut.unloadGrossWeightDouble ? detailRes.dZOrderListOut.unloadGrossWeightDouble : '',
          // unloadTareWeight: detailRes.dZOrderListOut.unloadTareWeightDouble ? detailRes.dZOrderListOut.unloadTareWeightDouble : '',
          // des: detailRes.dZOrderListOut.des ? detailRes.dZOrderListOut.des : '',
          // unloadNetWeightDouble: detailRes.dZOrderListOut.unloadNetWeightDouble ? detailRes.dZOrderListOut.unloadNetWeightDouble : '',
        };
      } else if (!systemData) {
        // 只有司机数据
        console.log('只有司机数据');
        this.cargoInfoDetailItemList.push([
          { label: '装货磅单', value: 'loadingPicUrl', type: 'img', attr: {limit: 1} },
          { label: '装货磅单号', value: 'weightNumber', type: 'input'},
          { label: '装货时间', value: 'loadingTime', type: 'date', attr: {type: 'datetime', time: '00:00:00', format: 'yyyy-MM-dd HH:mm:ss', valueFormat: 'yyyy-MM-dd HH:mm:ss'} },
          { label: '装货皮重', value: 'tareWeightDouble', type: 'input' },
          { label: '装货毛重', value: 'grossWeightDouble', type: 'input'},
          { label: '装货净重', value: 'netWeightDouble', type: 'input' },
          { label: '装货点', value: 'source', type: 'input' },
        ]);
        this.cargoInfoDetailItemList.push([
          { label: '卸货磅单', value: 'unloadPicUrl', type: 'img', attr: {limit: 1} },
          { label: '卸货磅单号', value: 'unloadNumber', type: 'input'},
          { label: '卸货时间', value: 'unloadTime', type: 'date', attr: {type: 'datetime', time: '00:00:00', format: 'yyyy-MM-dd HH:mm:ss', valueFormat: 'yyyy-MM-dd HH:mm:ss'} },
          { label: '卸货皮重', value: 'unloadTareWeight', type: 'input' },
          { label: '卸货毛重', value: 'unloadGrossWeight', type: 'input' },
          { label: '卸货净重', value: 'unloadNetWeightDouble', type: 'input' },
          { label: '卸货点', value: 'des', type: 'input'},
        ]);
        return {
          loadingPicUrl: detailRes.dZDriverOrderInfo.loadingPicUrl ? detailRes.dZDriverOrderInfo.loadingPicUrl : '',
          weightNumber: detailRes.dZDriverOrderInfo.weightNumber ? detailRes.dZDriverOrderInfo.weightNumber : '',
          loadingTime: detailRes.dZDriverOrderInfo.loadingTime ? detailRes.dZDriverOrderInfo.loadingTime : '',
          tareWeightDouble: detailRes.dZDriverOrderInfo.tareWeightDouble ? detailRes.dZDriverOrderInfo.tareWeightDouble : '',
          grossWeightDouble: detailRes.dZDriverOrderInfo.grossWeightDouble ? detailRes.dZDriverOrderInfo.grossWeightDouble : '',
          netWeightDouble: detailRes.dZDriverOrderInfo.netWeightDouble ? detailRes.dZDriverOrderInfo.netWeightDouble : '',
          source: detailRes.dZDriverOrderInfo.source ? detailRes.dZDriverOrderInfo.source : '',

          unloadPicUrl: detailRes.dZDriverOrderInfo.unloadPicUrl ? detailRes.dZDriverOrderInfo.unloadPicUrl : '',
          unloadNumber: detailRes.dZDriverOrderInfo.unloadNumber ? detailRes.dZDriverOrderInfo.unloadNumber : '',
          unloadTime: detailRes.dZDriverOrderInfo.unloadTime ? detailRes.dZDriverOrderInfo.unloadTime : '',
          unloadGrossWeight: detailRes.dZDriverOrderInfo.unloadGrossWeightDouble ? detailRes.dZDriverOrderInfo.unloadGrossWeightDouble : '',
          unloadTareWeight: detailRes.dZDriverOrderInfo.unloadTareWeightDouble ? detailRes.dZDriverOrderInfo.unloadTareWeightDouble : '',
          des: detailRes.dZDriverOrderInfo.des ? detailRes.dZDriverOrderInfo.des : '',
          unloadNetWeightDouble: detailRes.dZDriverOrderInfo.unloadNetWeightDouble ? detailRes.dZDriverOrderInfo.unloadNetWeightDouble : '',
        };
      } else {
        // 两者都存在
        if (!isLoadMatch && !isUnloadMatch) {
          console.log('装货卸货数据都不一致');
          // 装货和卸货数据不一致处理
          this.cargoInfoDetailItemList.push([
            {label: '装货磅单', value: 'loadingPicUrl', type: 'img', attr: {limit: 1}},
            {
              label: '装货磅单号', value: 'weightNumber', type: 'input',
              onChange: async (val) => {
                await _this.itemValueChange(_this, detailRes, 'weightNumber', val);
              },
            },
            {
              label: '装货时间',
              value: 'loadingTime',
              type: 'date',
              attr: {
                type: 'datetime',
                time: '00:00:00',
                format: 'yyyy-MM-dd HH:mm:ss',
                valueFormat: 'yyyy-MM-dd HH:mm:ss',
              },
              onChange: async (val) => {
                await _this.itemValueChange(_this, detailRes, 'loadingTime', val);
              },
            },
            {label: '装货皮重', value: 'tareWeightDouble', type: 'input',
              onChange: async (val) => {
                await _this.itemValueChange(_this, detailRes, 'tareWeightDouble', val);
              }},
            {label: '装货毛重', value: 'grossWeightDouble', type: 'input',
              onChange: async (val) => {
                await _this.itemValueChange(_this, detailRes, 'grossWeightDouble', val);
              }},
            {label: '装货净重', value: 'netWeightDouble', type: 'input',
              onChange: async (val) => {
                await _this.itemValueChange(_this, detailRes, 'netWeightDouble', val);
              }},
            {label: '装货点', value: 'source', type: 'input'},
          ]);
          const loadItemName = ['loadingPicUrl', 'weightNumber', 'loadingTime', 'tareWeightDouble', 'grossWeightDouble', 'netWeightDouble', 'source'];
          const driverDetailItem = this.getDriverDetailItem(systemLoad, driverLoad, loadItemName, detailRes);
          this.cargoInfoDetailItemList.push(driverDetailItem);
          this.cargoInfoDetailItemList.push([
            {label: '卸货磅单', value: 'unloadPicUrl', type: 'img', attr: {limit: 1}, disabled: true},
            {label: '卸货磅单号', value: 'unloadNumber', type: 'input', disabled: true},
            {
              label: '卸货时间',
              value: 'unloadTime',
              type: 'date',
              attr: {
                type: 'datetime',
                time: '00:00:00',
                format: 'yyyy-MM-dd HH:mm:ss',
                valueFormat: 'yyyy-MM-dd HH:mm:ss',
              },
              disabled: true,
            },
            {label: '卸货皮重', value: 'unloadTareWeight', type: 'input', disabled: true},
            {label: '卸货毛重', value: 'unloadGrossWeight', type: 'input', disabled: true},
            {label: '卸货净重', value: 'unloadNetWeightDouble', type: 'input', disabled: true},
            {label: '卸货点', value: 'des', type: 'input', disabled: true},
          ]);

          const unLoadItemName = ['unloadPicUrl', 'unloadNumber', 'unloadTime',
            'unloadTareWeight', 'unloadGrossWeight', 'unloadNetWeightDouble', 'des'];
          this.cargoInfoDetailItemList.push(this.getDriverDetailItem(systemUnload, driverUnload, unLoadItemName, detailRes));
          return {
            loadingPicUrl: detailRes.dZOrderListOut.loadingPicUrl ? detailRes.dZOrderListOut.loadingPicUrl : '',
            weightNumber: detailRes.dZOrderListOut.weightNumber ? detailRes.dZOrderListOut.weightNumber : '',
            loadingTime: detailRes.dZOrderListOut.loadingTime ? detailRes.dZOrderListOut.loadingTime : '',
            tareWeightDouble: detailRes.dZOrderListOut.tareWeightDouble ? detailRes.dZOrderListOut.tareWeightDouble : '',
            grossWeightDouble: detailRes.dZOrderListOut.grossWeightDouble ? detailRes.dZOrderListOut.grossWeightDouble : '',
            netWeightDouble: detailRes.dZOrderListOut.netWeightDouble ? detailRes.dZOrderListOut.netWeightDouble : '',
            source: detailRes.dZOrderListOut.source ? detailRes.dZOrderListOut.source : '',

            driverloadingPicUrl: detailRes.dZDriverOrderInfo.loadingPicUrl ? detailRes.dZDriverOrderInfo.loadingPicUrl : '',
            driverweightNumber: detailRes.dZDriverOrderInfo.weightNumber ? detailRes.dZDriverOrderInfo.weightNumber : '',
            driverloadingTime: detailRes.dZDriverOrderInfo.loadingTime ? detailRes.dZDriverOrderInfo.loadingTime : '',
            drivertareWeightDouble: detailRes.dZDriverOrderInfo.tareWeightDouble ? detailRes.dZDriverOrderInfo.tareWeightDouble : '',
            drivergrossWeightDouble: detailRes.dZDriverOrderInfo.grossWeightDouble ? detailRes.dZDriverOrderInfo.grossWeightDouble : '',
            drivernetWeightDouble: detailRes.dZDriverOrderInfo.netWeightDouble ? detailRes.dZDriverOrderInfo.netWeightDouble : '',
            driversource: detailRes.dZDriverOrderInfo.source ? detailRes.dZDriverOrderInfo.source : '',

            // unloadPicUrl: detailRes.dZOrderListOut.unloadPicUrl ? detailRes.dZOrderListOut.unloadPicUrl : 'https://www.baiduyuming.com/img/pdf.jpg',
            // unloadNumber: detailRes.dZOrderListOut.unloadNumber ? detailRes.dZOrderListOut.unloadNumber : '',
            // unloadTime: detailRes.dZOrderListOut.unloadTime ? detailRes.dZOrderListOut.unloadTime : '',
            // unloadGrossWeight: detailRes.dZOrderListOut.unloadGrossWeightDouble ? detailRes.dZOrderListOut.unloadGrossWeightDouble : '',
            // unloadTareWeight: detailRes.dZOrderListOut.unloadTareWeightDouble ? detailRes.dZOrderListOut.unloadTareWeightDouble : '',
            // des: detailRes.dZOrderListOut.des ? detailRes.dZOrderListOut.des : '',
            // unloadNetWeightDouble: detailRes.dZOrderListOut.unloadNetWeightDouble ? detailRes.dZOrderListOut.unloadNetWeightDouble : '',

            driverunloadPicUrl: detailRes.dZDriverOrderInfo.unloadPicUrl ? detailRes.dZDriverOrderInfo.unloadPicUrl : '',
            driverunloadNumber: detailRes.dZDriverOrderInfo.unloadWeightNumber ? detailRes.dZDriverOrderInfo.unloadWeightNumber : '',
            driverunloadTime: detailRes.dZDriverOrderInfo.unloadTime ? detailRes.dZDriverOrderInfo.unloadTime : '',
            driverunloadGrossWeight: detailRes.dZDriverOrderInfo.unloadGrossWeightDouble ? detailRes.dZDriverOrderInfo.unloadGrossWeightDouble : '',
            driverunloadTareWeight: detailRes.dZDriverOrderInfo.unloadTareWeightDouble ? detailRes.dZDriverOrderInfo.unloadTareWeightDouble : '',
            driverdes: detailRes.dZDriverOrderInfo.source ? detailRes.dZDriverOrderInfo.source : '',
            driverunloadNetWeightDouble: detailRes.dZDriverOrderInfo.unloadNetWeightDouble ? detailRes.dZDriverOrderInfo.unloadNetWeightDouble : '',
          };
        } else if (!isLoadMatch) {
          console.log('只有装货数据不一致');
          // 只有装货数据不一致
          this.cargoInfoDetailItemList.push([
            {label: '装货磅单', value: 'loadingPicUrl', type: 'img', attr: {limit: 1}},
            {
              label: '装货磅单号', value: 'weightNumber', type: 'input',
              onChange: async (val) => {
                await _this.itemValueChange(_this, detailRes, 'weightNumber', val);
              },
            },
            {
              label: '装货时间',
              value: 'loadingTime',
              type: 'date',
              attr: {
                type: 'datetime',
                time: '00:00:00',
                format: 'yyyy-MM-dd HH:mm:ss',
                valueFormat: 'yyyy-MM-dd HH:mm:ss',
              },
              onChange: async (val) => {
                await _this.itemValueChange(_this, detailRes, 'loadingTime', val);
              },
            },
            {label: '装货皮重', value: 'tareWeightDouble', type: 'input',
              onChange: async (val) => {
                await _this.itemValueChange(_this, detailRes, 'tareWeightDouble', val);
              }},
            {label: '装货毛重', value: 'grossWeightDouble', type: 'input',
              onChange: async (val) => {
                await _this.itemValueChange(_this, detailRes, 'grossWeightDouble', val);
              }},
            {label: '装货净重', value: 'netWeightDouble', type: 'input',
              onChange: async (val) => {
                await _this.itemValueChange(_this, detailRes, 'netWeightDouble', val);
              }},
            {label: '装货点', value: 'source', type: 'input'},
          ]);
          const loadItemName = ['loadingPicUrl', 'weightNumber', 'loadingTime', 'tareWeightDouble', 'grossWeightDouble', 'netWeightDouble', 'source'];
          const driverDetailItem = this.getDriverDetailItem(systemLoad, driverLoad, loadItemName, detailRes);
          this.cargoInfoDetailItemList.push(driverDetailItem);
          this.cargoInfoDetailItemList.push([
            {label: '卸货磅单', value: 'unloadPicUrl', type: 'img', attr: {limit: 1}},
            {label: '卸货磅单号', value: 'unloadNumber', type: 'input'},
            {label: '卸货时间', value: 'unloadTime', type: 'input'},
            {label: '卸货皮重', value: 'unloadTareWeight', type: 'input'},
            {label: '卸货毛重', value: 'unloadGrossWeight', type: 'input'},
            {label: '卸货净重', value: 'unloadNetWeightDouble', type: 'input'},
            {label: '卸货点', value: 'des'},
          ]);
          this.cargoInfoDetailItemList.push([
            {value: 'driverunloadPicUrl', type: 'img', attr: {limit: 1}, isDifferent: false},
            {lvalue: 'driverunloadweightNumber', type: 'input', isDifferent: false},
            {value: 'driverunloadTime', type: 'date', isDifferent: false},
            {value: 'driverunloadtareWeightDouble', type: 'input', isDifferent: false},
            {value: 'driverunloadgrossWeightDouble', type: 'input', isDifferent: false},
            {value: 'driverunloadnetWeightDouble', type: 'input', isDifferent: false},
            {value: 'driverdes', type: 'input', isDifferent: false},
          ]);
          return {
            loadingPicUrl: detailRes.dZOrderListOut.loadingPicUrl ? detailRes.dZOrderListOut.loadingPicUrl : '',
            weightNumber: detailRes.dZOrderListOut.weightNumber ? detailRes.dZOrderListOut.weightNumber : '',
            loadingTime: detailRes.dZOrderListOut.loadingTime ? detailRes.dZOrderListOut.loadingTime : '',
            tareWeightDouble: detailRes.dZOrderListOut.tareWeightDouble ? detailRes.dZOrderListOut.tareWeightDouble : '',
            grossWeightDouble: detailRes.dZOrderListOut.grossWeightDouble ? detailRes.dZOrderListOut.grossWeightDouble : '',
            netWeightDouble: detailRes.dZOrderListOut.netWeightDouble ? detailRes.dZOrderListOut.netWeightDouble : '',
            source: detailRes.dZOrderListOut.source ? detailRes.dZOrderListOut.source : '',

            driverloadingPicUrl: detailRes.dZDriverOrderInfo.loadingPicUrl ? detailRes.dZDriverOrderInfo.loadingPicUrl : '',
            driverweightNumber: detailRes.dZDriverOrderInfo.weightNumber ? detailRes.dZDriverOrderInfo.weightNumber : '',
            driverloadingTime: detailRes.dZDriverOrderInfo.loadingTime ? detailRes.dZDriverOrderInfo.loadingTime : '',
            drivertareWeightDouble: detailRes.dZDriverOrderInfo.tareWeightDouble ? detailRes.dZDriverOrderInfo.tareWeightDouble : '',
            drivergrossWeightDouble: detailRes.dZDriverOrderInfo.grossWeightDouble ? detailRes.dZDriverOrderInfo.grossWeightDouble : '',
            drivernetWeightDouble: detailRes.dZDriverOrderInfo.netWeightDouble ? detailRes.dZDriverOrderInfo.netWeightDouble : '',
            driversource: detailRes.dZDriverOrderInfo.source ? detailRes.dZDriverOrderInfo.source : '',

            // unloadPicUrl: detailRes.dZOrderListOut.unloadPicUrl ? detailRes.dZOrderListOut.unloadPicUrl : '',
            // unloadNumber: detailRes.dZOrderListOut.unloadNumber ? detailRes.dZOrderListOut.unloadNumber : '',
            // unloadTime: detailRes.dZOrderListOut.unloadTime ? detailRes.dZOrderListOut.unloadTime : '',
            // unloadGrossWeight: detailRes.dZOrderListOut.unloadGrossWeightDouble ? detailRes.dZOrderListOut.unloadGrossWeightDouble : '',
            // unloadTareWeight: detailRes.dZOrderListOut.unloadTareWeightDouble ? detailRes.dZOrderListOut.unloadTareWeightDouble : '',
            // des: detailRes.dZOrderListOut.des ? detailRes.dZOrderListOut.des : '',
            // unloadNetWeightDouble: detailRes.dZOrderListOut.unloadNetWeightDouble ? detailRes.dZOrderListOut.unloadNetWeightDouble : '',

            driverunloadPicUrl: detailRes.dZDriverOrderInfo.loadingPicUrl ? detailRes.dZDriverOrderInfo.loadingPicUrl : '',
            driverunloadNumber: detailRes.dZDriverOrderInfo.unloadWeightNumber ? detailRes.dZDriverOrderInfo.unloadWeightNumber : '',
            driverunloadTime: detailRes.dZDriverOrderInfo.unloadTime ? detailRes.dZDriverOrderInfo.unloadTime : '',
            driverunloadGrossWeight: detailRes.dZDriverOrderInfo.unloadGrossWeightDouble ? detailRes.dZDriverOrderInfo.unloadGrossWeightDouble : '',
            driverunloadTareWeight: detailRes.dZDriverOrderInfo.unloadTareWeightDouble ? detailRes.dZDriverOrderInfo.unloadTareWeightDouble : '',
            driverdes: detailRes.dZDriverOrderInfo.source ? detailRes.dZDriverOrderInfo.source : '',
            driverunloadNetWeightDouble: detailRes.dZDriverOrderInfo.unloadNetWeightDouble ? detailRes.dZDriverOrderInfo.unloadNetWeightDouble : '',
          };
        } else if (!isUnloadMatch) {
          console.log('只有卸货数据不一致');
          // 只有卸货数据不一致
          this.cargoInfoDetailItemList.push([
            {label: '装货磅单', value: 'loadingPicUrl', type: 'img'},
            {label: '装货磅单号', value: 'weightNumber'},
            {label: '装货时间', value: 'loadingTime'},
            {label: '装货皮重', value: 'tareWeightDouble'},
            {label: '装货毛重', value: 'grossWeightDouble'},
            {label: '装货净重', value: 'netWeightDouble'},
            {label: '装货点', value: 'source'},
          ]);
          this.cargoInfoDetailItemList.push([
            {label: '卸货磅单', value: 'unloadPicUrl', type: 'img'},
            {label: '卸货磅单号', value: 'unloadNumber'},
            {label: '卸货时间', value: 'unloadTime'},
            {label: '卸货皮重', value: 'unloadTareWeight'},
            {label: '卸货毛重', value: 'unloadGrossWeight'},
            {label: '卸货净重', value: 'unloadNetWeightDouble'},
            {label: '卸货点', value: 'des'},
          ]);
          this.cargoInfoDetailItemList.push([
            {value: 'driverunloadPicUrl', type: 'img', isDifferent: true},
            {lvalue: 'driverunloadNumber', isDifferent: true},
            {value: 'driverunloadTime', isDifferent: true},
            {value: 'driverunloadTareWeight', isDifferent: true},
            {value: 'driverunloadGrossWeight', isDifferent: true},
            {value: 'driverunloadNetWeightDouble', isDifferent: true},
            {value: 'driverdes', isDifferent: true},
          ]);
          return {
            loadingPicUrl: detailRes.dZOrderListOut.loadingPicUrl ? detailRes.dZOrderListOut.loadingPicUrl : '',
            weightNumber: detailRes.dZOrderListOut.weightNumber ? detailRes.dZOrderListOut.weightNumber : '',
            loadingTime: detailRes.dZOrderListOut.loadingTime ? detailRes.dZOrderListOut.loadingTime : '',
            tareWeightDouble: detailRes.dZOrderListOut.tareWeightDouble ? detailRes.dZOrderListOut.tareWeightDouble : '',
            grossWeightDouble: detailRes.dZOrderListOut.grossWeightDouble ? detailRes.dZOrderListOut.grossWeightDouble : '',
            netWeightDouble: detailRes.dZOrderListOut.netWeightDouble ? detailRes.dZOrderListOut.netWeightDouble : '',
            source: detailRes.dZOrderListOut.source ? detailRes.dZOrderListOut.source : '',

            // driverloadingPicUrl: detailRes.dZDriverOrderInfo.loadingPicUrl ? detailRes.dZDriverOrderInfo.loadingPicUrl : '',
            // driverweightNumber: detailRes.dZDriverOrderInfo.weightNumber ? detailRes.dZDriverOrderInfo.weightNumber : '',
            // driverloadingTime: detailRes.dZDriverOrderInfo.loadingTime ? detailRes.dZDriverOrderInfo.loadingTime : '',
            // drivertareWeightDouble: detailRes.dZDriverOrderInfo.tareWeightDouble ? detailRes.dZDriverOrderInfo.tareWeightDouble : '',
            // drivergrossWeightDouble: detailRes.dZDriverOrderInfo.grossWeightDouble ? detailRes.dZDriverOrderInfo.grossWeightDouble : '',
            // drivernetWeightDouble: detailRes.dZDriverOrderInfo.netWeightDouble ? detailRes.dZDriverOrderInfo.netWeightDouble : '',
            // driversource: detailRes.dZDriverOrderInfo.source ? detailRes.dZDriverOrderInfo.source : '',

            // unloadPicUrl: detailRes.dZOrderListOut.unloadPicUrl ? detailRes.dZOrderListOut.unloadPicUrl : '',
            // unloadNumber: detailRes.dZOrderListOut.unloadNumber ? detailRes.dZOrderListOut.unloadNumber : '',
            // unloadTime: detailRes.dZOrderListOut.unloadTime ? detailRes.dZOrderListOut.unloadTime : '',
            // unloadGrossWeight: detailRes.dZOrderListOut.unloadGrossWeightDouble ? detailRes.dZOrderListOut.unloadGrossWeightDouble : '',
            // unloadTareWeight: detailRes.dZOrderListOut.unloadTareWeightDouble ? detailRes.dZOrderListOut.unloadTareWeightDouble : '',
            // des: detailRes.dZOrderListOut.des ? detailRes.dZOrderListOut.des : '',
            // unloadNetWeightDouble: detailRes.dZOrderListOut.unloadNetWeightDouble ? detailRes.dZOrderListOut.unloadNetWeightDouble : '',

            driverunloadPicUrl: detailRes.dZDriverOrderInfo.loadingPicUrl ? detailRes.dZDriverOrderInfo.loadingPicUrl : '',
            driverunloadNumber: detailRes.dZDriverOrderInfo.unloadWeightNumber ? detailRes.dZDriverOrderInfo.unloadWeightNumber : '',
            driverunloadTime: detailRes.dZDriverOrderInfo.unloadTime ? detailRes.dZDriverOrderInfo.unloadTime : '',
            driverunloadGrossWeight: detailRes.dZDriverOrderInfo.unloadGrossWeightDouble ? detailRes.dZDriverOrderInfo.unloadGrossWeightDouble : '',
            driverunloadTareWeight: detailRes.dZDriverOrderInfo.unloadTareWeightDouble ? detailRes.dZDriverOrderInfo.unloadTareWeightDouble : '',
            driverdes: detailRes.dZDriverOrderInfo.source ? detailRes.dZDriverOrderInfo.source : '',
            driverunloadNetWeightDouble: detailRes.dZDriverOrderInfo.unloadNetWeightDouble ? detailRes.dZDriverOrderInfo.unloadNetWeightDouble : '',
          };
        } else {
          // 装货和卸货数据都一致
          this.cargoInfoDetailItemList.push([
            {label: '装货磅单', value: 'loadingPicUrl', type: 'img'},
            {label: '装货磅单号', value: 'weightNumber'},
            {label: '装货时间', value: 'loadingTime'},
            {label: '装货皮重', value: 'tareWeightDouble'},
            {label: '装货毛重', value: 'grossWeightDouble'},
            {label: '装货净重', value: 'netWeightDouble'},
            {label: '装货点', value: 'source'},
          ]);
          this.cargoInfoDetailItemList.push([
            {label: '卸货磅单', value: 'unloadPicUrl', type: 'img'},
            {label: '卸货磅单号', value: 'unloadNumber'},
            {label: '卸货时间', value: 'unloadTime'},
            {label: '卸货皮重', value: 'unloadTareWeight'},
            {label: '卸货毛重', value: 'unloadGrossWeight'},
            {label: '卸货净重', value: 'unloadNetWeightDouble'},
            {label: '卸货点', value: 'des'},
          ]);
          return {
            loadingPicUrl: detailRes.dZOrderListOut.loadingPicUrl ? detailRes.dZOrderListOut.loadingPicUrl : '',
            weightNumber: detailRes.dZOrderListOut.weightNumber ? detailRes.dZOrderListOut.weightNumber : '',
            loadingTime: detailRes.dZOrderListOut.loadingTime ? detailRes.dZOrderListOut.loadingTime : '',
            tareWeightDouble: detailRes.dZOrderListOut.tareWeightDouble ? detailRes.dZOrderListOut.tareWeightDouble : '',
            grossWeightDouble: detailRes.dZOrderListOut.grossWeightDouble ? detailRes.dZOrderListOut.grossWeightDouble : '',
            netWeightDouble: detailRes.dZOrderListOut.netWeightDouble ? detailRes.dZOrderListOut.netWeightDouble : '',
            source: detailRes.dZOrderListOut.source ? detailRes.dZOrderListOut.source : '',

            unloadPicUrl: detailRes.dZOrderListOut.unloadPicUrl ? detailRes.dZOrderListOut.unloadPicUrl : '',
            unloadNumber: detailRes.dZOrderListOut.unloadNumber ? detailRes.dZOrderListOut.unloadNumber : '',
            unloadTime: detailRes.dZOrderListOut.unloadTime ? detailRes.dZOrderListOut.unloadTime : '',
            unloadGrossWeight: detailRes.dZOrderListOut.unloadGrossWeightDouble ? detailRes.dZOrderListOut.unloadGrossWeightDouble : '',
            unloadTareWeight: detailRes.dZOrderListOut.unloadTareWeightDouble ? detailRes.dZOrderListOut.unloadTareWeightDouble : '',
            des: detailRes.dZOrderListOut.des ? detailRes.dZOrderListOut.des : '',
            unloadNetWeightDouble: detailRes.dZOrderListOut.unloadNetWeightDouble ? detailRes.dZOrderListOut.unloadNetWeightDouble : '',
          };
        }
      }
    },
    // 运费信息
    getFreightDetailData (data) {
      return {
        settlementUnitPrice: (data.settlementUnitPriceDouble ? data.settlementUnitPriceDouble : 0) + '元',
        originalSettlementPrice: (data.originalSettlementPrice ? data.originalSettlementPrice : 0) + '元',
        goodsUnitPrice: (data.goodsUnitPriceDouble ? data.goodsUnitPriceDouble : 0) + '元/吨',
        deductions: (data.deductions ? data.deductions : 0) + '元',
        settlementPrice: (data.settlementPrice ? data.settlementPrice : 0) + '元',
        settlementMethodStr: data.settlementMethodStr,
        deductionsScaleDouble: data.deductionsScaleDouble,
      };
    },
    async handleForm () {
      let length = this.cargoInfoDetailItemList.length;
      const { dZOrderListOut: systemData, dZDriverOrderInfo: driverData } = this.detailRes;
      if (!driverData) {
        this.orderLoadInfo.form.push(...this.cargoInfoDetailItemList[0]);
        this.orderUnloadInfo.form.push(...this.cargoInfoDetailItemList[1]);
      } else if (!systemData) {
        this.driverLoadInfo.form.push(...this.cargoInfoDetailItemList[0]);
        this.driverUnloadInfo.form.push(...this.cargoInfoDetailItemList[1]);
        setTimeout(() => {
          this.$refs.driverLoadInfo.setVal('loadingPicUrl', this.detailRes.dZDriverOrderInfo.loadingPic);
          this.$refs.driverUnloadInfo.setVal('unloadPicUrl', this.detailRes.dZDriverOrderInfo.unloadPic);
        }, 100);
      }
      if (length > 3) {
        this.orderLoadInfo.form.push(...this.cargoInfoDetailItemList[0]);
        this.driverLoadInfo.form.push(...this.cargoInfoDetailItemList[1]);
        this.orderUnloadInfo.form.push(...this.cargoInfoDetailItemList[2]);
        this.driverUnloadInfo.form.push(...this.cargoInfoDetailItemList[3]);
        setTimeout(() => {
          this.$refs.driverLoadInfo.setVal('driverloadingPicUrl', this.detailRes.dZDriverOrderInfo.loadingPic);
          this.$refs.driverUnloadInfo.setVal('driverunloadPicUrl', this.detailRes.dZDriverOrderInfo.unloadPic);
        }, 100);
      }
      setTimeout(() => {
        // 系统装货
        this.$refs.orderLoadInfo.setVal(this.orderDetail.base.cargoInfoDetail),
        // 司机装货
        this.$refs.driverLoadInfo.setVal(this.orderDetail.base.cargoInfoDetail),
        // 系统卸货
        this.$refs.orderUnloadInfo.setVal(this.orderDetail.base.cargoInfoDetail);
        // 司机卸货
        this.$refs.driverUnloadInfo.setVal(this.orderDetail.base.cargoInfoDetail);

      }, 10);
    },
    // 修改装卸货信息
    async handelCargoInfoSub () {
      const orderLoadFormData = await this.$refs.orderLoadInfo.getVal(); // 获取 系统装货 表单数据
      const driverLoadFormData = await this.$refs.driverLoadInfo.getVal();// 获取 司机装货 表单数据
      const driverUnloadFormData = await this.$refs.driverUnloadInfo.getVal(); // 获取 司机卸货 表单数据
      console.log('系统装货formData', orderLoadFormData);
      console.log('司机装货formData', driverLoadFormData);
      console.log('司机卸货formData', driverUnloadFormData);

      let DZOrderInfo = {
        orderId: this.detailRes.dZOrderListOut ? this.detailRes.dZOrderListOut.orderId : this.detailRes.dZDriverOrderInfo.orderId,
        weightNumber: orderLoadFormData.weightNumber,
        loadingTime: orderLoadFormData.loadingTime ? this.formatDate(orderLoadFormData.loadingTime, 1) : '',
        grossWeight: orderLoadFormData.grossWeightDouble,
        tareWeight: orderLoadFormData.tareWeightDouble,
        netWeight: orderLoadFormData.netWeightDouble,
      };
      console.log('pc提交', DZOrderInfo);
      let DZDriverOrderInfo = {
        orderId: this.detailRes.dZOrderListOut ? this.detailRes.dZOrderListOut.orderId : this.detailRes.dZDriverOrderInfo.orderId,
        weightNumber: driverLoadFormData.driverweightNumber || driverLoadFormData.weightNumber,
        loadingTime: (driverLoadFormData.driverloadingTime ? this.formatDate(driverLoadFormData.driverloadingTime, 1) : '') || (driverLoadFormData.loadingTime ? this.formatDate(driverLoadFormData.loadingTime, 1) : ''),
        grossWeight: driverLoadFormData.drivergrossWeightDouble || driverLoadFormData.grossWeightDouble,
        tareWeight: driverLoadFormData.drivertareWeightDouble || driverLoadFormData.tareWeightDouble,
        netWeight: driverLoadFormData.drivernetWeightDouble || driverLoadFormData.netWeightDouble,

        unloadWeightNumber: driverUnloadFormData.driverunloadNumber || driverUnloadFormData.unloadNumber,
        unloadTime: (driverUnloadFormData.driverunloadTime ? this.formatDate(driverUnloadFormData.driverunloadTime, 1) : '') || (driverUnloadFormData.unloadTime ? this.formatDate(driverUnloadFormData.unloadTime, 1) : ''),
        unloadGrossWeight: driverUnloadFormData.driverunloadGrossWeight || driverUnloadFormData.unloadGrossWeight,
        unloadTareWeight: driverUnloadFormData.driverunloadTareWeight || driverUnloadFormData.unloadTareWeight,
        unloadNetWeight: driverUnloadFormData.driverunloadNetWeightDouble || driverUnloadFormData.unloadNetWeightDouble,
      };
      console.log('司机提交', DZDriverOrderInfo);

      let resultFormData = {};
      Object.keys(DZOrderInfo).forEach((item) => {
        const prefixedKey = `DZOrderInfo.${item}`;
        resultFormData[prefixedKey] = DZOrderInfo[item] || ''; // 空值转为空字符串
      });
      Object.keys(DZDriverOrderInfo).forEach((item) => {
        const prefixedKey = `DZDriverOrderInfo.${item}`;
        resultFormData[prefixedKey] = DZDriverOrderInfo[item] || '';
      });
      const res = await updateLoadingAndUnloadDatas({
        ...resultFormData,
      });
      if (!res.failed) {
        this.$message({
          type: 'success',
          message: '保存成功！',
        });
        this.close();
      }

    },
    async getData (detailRes) {
      // 详情数据
      this.orderDetail = {};
      // 重写各个模块的 详情数据，方便和 审核数据 做对比
      this.detailRes = detailRes;
      if (detailRes.dZDriverOrderInfo) {
        await this.findImgUrlById(detailRes.dZDriverOrderInfo);
      }
      await this.setBaseData(detailRes);
      if (this.$route.query.type === 'edit') {
        this.isEdit = this.$route.query.type;
        await this.handleForm();
      }
    },
  },
};
</script>

<style scoped>
.detail-item-inline-box {
  display: flex;
  justify-content: space-between;
  gap: 16px; /* 列之间的间距 */
}

.detail-item-column {
  flex: 1; /* 每列平分宽度 */
  min-width: 0; /* 防止内容溢出 */

  padding: 0 8px;
}

.detail-item-column:last-child {
  border-right: none; /* 最后一列去掉右边框 */
}

/* 动态设置列数 */
.detail-item-inline-box {
  --column-count: 2; /* 默认 2 列 */
  display: grid;
  grid-template-columns: repeat(var(--column-count), 1fr); /* 动态列数 */
}

</style>
